export default __webpack_public_path__ + "static/module-03-045bc867c8cc77ec05c9d08455581f1e.svg";